import React, { useContext, useEffect, useState } from "react";
import PageTitleBanner from "../../Components/Reusable/PageTitleBanner";
import Image from "../../Components/Reusable/Image";
import { PngImages } from "../../Utils/LocalImages";
import SubmitButton from "../../Components/Reusable/Buttons";
import CustomTextField from "../../Components/Reusable/CustomTextField";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { InputType, handleApiErrors, validationRegex } from "../../Utils/Utils";
import { useForm } from "react-hook-form";
import ApiService from "../../Services/ApiService";
import CustomDropDown from "../../Components/Reusable/CustomDropDown";
import DataProvider from "../../Utils/DataProvider";
import CustomDatePicker from "../../Components/Reusable/CustomDatePicker";
import { Link, useNavigate } from "react-router-dom";
import RoutesPath from "../../Utils/RoutesPath";
import { toast } from "react-toastify";
import SessionManager from "../../Utils/Session";
import { AuthContext } from "../../Context/authContext";

const JoinAsCoordinator = () => {
  const { coordinator } = useContext(AuthContext);
  const [showDistrict, setShowDistrict] = useState(true);
  const [showTaluka, setShowTaluka] = useState(true);
  const [showPinCode, setShowPinCode] = useState(true);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [talukas, setTalukas] = useState([]);
  const [pincodes, setPincodes] = useState([]);
  const [resetDistrict, setResetDistrict] = useState(false);
  const [resetTaluka, setResetTaluka] = useState(false);
  const [resetPinCode, setResetPinCode] = useState(false);
  const [resetQualification, SetResetQualification] = useState(false);
  const [resetState, SetResetState] = useState(false);
  const [resetDate, SetResetDate] = useState(false);
  const sessionToken = SessionManager.shared.getCoordinatorToken();
  const navigate = useNavigate()

  const validationSchema = Yup.object().shape({
    name: validationRegex.required,
    email: validationRegex.email,
    dateOfBirth: validationRegex.dob,
    mobile: validationRegex.mobile,
    terms: validationRegex.terms,
    qualification: validationRegex.required,
    addressLineOne: validationRegex.required,
    addressLineTwo: validationRegex.required,
    state: validationRegex.required,
    district: showDistrict
      ? validationRegex.required
      : Yup.string().notRequired(),
    taluka: showTaluka ? validationRegex.required : Yup.string().notRequired(),
    pinCode: showPinCode
      ? validationRegex.required
      : Yup.string().notRequired(),
  });

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch: watchdetails,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (data) => {
    try {
      await ApiService.submitCoordinatorApi(data);
      reset();
      SetResetState(true)
      SetResetQualification(true)
      SetResetDate(true)
      toast.success("Registration Successful!");
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const getAllStates = async () => {
    try {
      const response = await ApiService.getAllStates();
      setStates(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  };

  useEffect(() => {
    getAllStates();
  }, [])


  return (
    <div className="d-flex flex-column mb-auto">
      <PageTitleBanner
        PageHead={"Join Learn and Achieve Edutech as a Coordinator for"}
        PageTitle={"Bharat SAT Examination"}
        breadCrumpPageTitle={"Join as a Co-ordinator"}
      />
      <div className="text-content-page-container d-flex flex-column align-items-center mb-0">
        <div className="coordinator-first-section d-flex gap-5 container">
          <div className="coordinator-first-section-text-content d-flex flex-column gap-3 container p-0 w-50 minirespo">
            <h2 className="Heading headingColor mb-0 fw-600">Who Can Join?</h2>
            <p className="medium-text subTextColor mb-0">
              If you're 18 years or older and have completed your 12th grade,
              you're eligible to join us as a Coordinator. Your age and
              qualification are your assets in this endeavor.
            </p>
            <div className={`d-flex justify-content-start  align-items-center mt-0 Submitbuttonmobile`}>
              {sessionToken && coordinator.coordinator_id ?
                <SubmitButton title={"Go to Coordinator Dashboard"} onClick={() => navigate(RoutesPath.dashboardcoordinator)} />
                :
                <Link to={RoutesPath.cologin}>
                  <SubmitButton
                    title={"Login As Coordinator"}
                  />
                </Link>
              }

            </div>

          </div>

          <div
            className="coordinator-card flex-row w-100 align-items-center ms-5"
            style={{ backgroundColor: "#FFE6CE" }}
          >
            <Image
              className="coordinator-card-person"
              src={PngImages.CoordinatorCardPerson}
            />
            <p className="medium-text fw-400 black mb-0">
              Are you a passionate individual looking to make a positive impact
              on the education landscape? Are you motivated to empower students
              in their quest for success? If so, we invite you to become a
              Coordinator with Learn and Achieve Edutech, where opportunities
              abound and your potential is unlimited.
            </p>
          </div>
        </div>
      </div>

      <div
        className="bharat-sat-benefits coordinate-category-background w-100 d-flex flex-column"
        style={{ backgroundColor: "#F4F4F4" }}
      >
        <div className="d-flex flex-column container coordinate-categories">
          <h2 className="Heading headingColor mb-0 fw-600 text-center">
            Two Exciting Categories
          </h2>
          <div className="coordinate-category-container d-flex align-items-start">
            <div className="coordinator-category-heading d-flex gap-2 align-items-center">
              <div className="coordinator-category-line" />
              <h2
                className="Small-Heading darkBlueColor mb-0 fw-600"
                style={{ whiteSpace: "nowrap" }}
              >
                Direct Coordinator
              </h2>
            </div>
            <p className="coordinator-category-description medium-text fw-400 black mb-0">
              As a Direct Coordinator, you'll directly engage with parents and
              students, helping them register for the prestigious Bharat SAT
              Examination and offering our top-notch online study materials. Be
              the guiding light on their educational journey.
            </p>
          </div>

          <div className="coordinate-category-container d-flex align-items-start">
            <div className="coordinator-category-heading d-flex gap-2 align-items-center">
              <div className="coordinator-category-line" />
              <h2
                className="Small-Heading darkBlueColor mb-0 fw-600"
                style={{ whiteSpace: "nowrap" }}
              >
                Indirect Coordinator
              </h2>
            </div>
            <p className="coordinator-category-description medium-text fw-400 black mb-0">
              If you prefer working with schools, our Indirect Coordinator role
              is perfect for you. Collaborate with our Learn and Achieve Edutech
              team to enroll students in the Bharat SAT Examination through
              their schools. Team up with us to make education accessible to
              all.
            </p>
          </div>
        </div>
      </div>

      <div className="coordinator-benefits-container d-flex w-100 container">
        <div className="row g-3">
          <div className="col-lg-7 col-md-12 row g-3 p-0 m-0">
            <div className="col-md-6">
              <div
                className="coordinator-text-content-card"
                style={{ backgroundColor: "#FFF3E1" }}
              >
                <h3 className="large-text fw-600 darkBlueColor mb-0">
                  Your Choice, Your Path
                </h3>
                <p className="medium-text fw-400 black mb-0 mt-2">
                  Choose the category that resonates with your skills and
                  interests. We trust you to make the best choice for your
                  unique abilities. After selection and appointment by Learn and
                  Achieve Edutech, you'll embark on an exciting journey in your
                  chosen domain.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div
                className="coordinator-text-content-card"
                style={{ backgroundColor: "#DCFFD3" }}
              >
                <h3 className="large-text fw-600 darkBlueColor mb-0">
                  Rewards for Excellence
                </h3>
                <p className="medium-text fw-400 black mb-0 mt-2">
                  At Learn and Achieve Edutech, we believe in recognizing and rewarding your performance. You'll earn incentives that directly reflect your dedication and results. The harder you work, the more you can achieve.

                </p>
              </div>
            </div>

            <div className="col-md-12">
              <div
                className="coordinator-text-content-card"
                style={{ backgroundColor: "#D6F6FF" }}
              >
                <div className="coordinator-rewards-container d-flex gap-4 align-items-center">
                  <Image
                    className="coordinator-rewards-image"
                    src={PngImages.rewardCoordinator}
                    style={{ height: 150 }}
                  />
                  <div className="d-flex flex-column gap-2">
                    <h3 className="large-text fw-600 darkBlueColor mb-0">
                      Join Us, Embrace Opportunity
                    </h3>
                    <p className="medium-text fw-400 black mb-0 mt-2">
                      It's time to embrace an exciting opportunity with Learn and Achieve Edutech. We welcome both male and female candidates with a passion for education, a drive for success, and a commitment to making a difference in the lives of students across India

                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-5 col-md-12">
            <div
              className="coordinator-text-content-card justify-content-between"
              style={{ backgroundColor: "#F6FFD2" }}
            >
              <div className="d-flex flex-column">
                <h3 className="large-text fw-600 darkBlueColor mb-0">
                  Compliance is Key
                </h3>
                <p className="medium-text fw-400 black mb-0 mt-2">
                  Every Coordinator must adhere to the terms and conditions of
                  Learn and Achieve. We prioritize ethical conduct,
                  transparency, and dedication to our mission of fostering
                  quality education.
                </p>
              </div>
              <Image
                className="align-self-end mt-3"
                src={PngImages.compilanceCoordinator}
                style={{ width: "min(75%, 400px)" }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="join-as-coordinator-form-backgroundpart">
        <div className="join-as-coordinator-form-background coordinator-benefits-container container ">
          <h2 className={`Heading fw-600 mb-0 white`}>Join Us</h2>
          <form
            action=""
            className="join-as-coordinator-form d-flex flex-column gap-4 justify-content-between"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="row g-space mt-4">
              <div className="col-md-4">
                <CustomTextField
                  labelTitle="Name"
                  id="name"
                  name="name"
                  inputType={InputType.text}
                  placeholder="Enter your name"
                  showError={errors?.name}
                  errorMessage={errors?.name?.message}
                  register={register}
                />
              </div>

              <div className="col-md-4">
                <CustomTextField
                  labelTitle="Email ID"
                  id="email"
                  name="email"
                  inputType={InputType.email}
                  placeholder="Enter your email id"
                  showError={errors?.email}
                  errorMessage={errors?.email?.message}
                  register={register}
                />
              </div>
              <div className="col-md-4">
                <CustomTextField
                  labelTitle="Mobile No"
                  id="mobile"
                  name="mobile"
                  placeholder="Enter your mobile no"
                  inputType={InputType.number}
                  showError={errors?.mobile}
                  errorMessage={errors?.mobile?.message}
                  register={register}
                />
              </div>
              <div className="col-md-4">
                <CustomDatePicker
                  labelTitle="Date of Birth"
                  id="dateOfBirth"
                  name="dateOfBirth"
                  inputType={InputType.date}
                  isWhiteTheme={true}
                  showError={errors?.dateOfBirth}
                  errorMessage={errors?.dateOfBirth?.message}
                  setValue={setValue}
                  register={register}
                  resetValue={resetDate}
                  setResetValue={SetResetDate}
                />
              </div>
              <div className="col-md-4">
                <CustomDropDown
                  labelTitle="Qualification"
                  id="qualification"
                  name="qualification"
                  placeholder="Select qualification"
                  isWhiteTheme={true}
                  options={DataProvider.Qualification}
                  register={register}
                  setValue={setValue}
                  resetValue={resetQualification}
                  setResetValue={SetResetQualification}
                  showError={errors?.qualification}
                  errorMessage={errors?.qualification?.message}
                />
              </div>
              <div className="col-md-4">
                <CustomTextField
                  labelTitle="Address Line-1"
                  id="addressLineOne"
                  name="addressLineOne"
                  inputType={InputType.text}
                  placeholder="Enter your address"
                  register={register}
                  setValue={setValue}
                  showError={errors?.addressLineOne}
                  errorMessage={errors?.addressLineOne?.message}
                />
              </div>

              <div className="col-md-4">
                <CustomTextField
                  labelTitle="Address Line-2"
                  id="addressLineTwo"
                  name="addressLineTwo"
                  inputType={InputType.text}
                  placeholder="Enter your address"
                  showError={errors?.addressLineTwo}
                  errorMessage={errors?.addressLineTwo?.message}
                  register={register}
                  setValue={setValue}
                />
              </div>
              <div className="col-md-4">
                <CustomDropDown
                  labelTitle="State"
                  id="state"
                  name="state"
                  placeholder="Select State"
                  showError={errors?.state}
                  errorMessage={errors?.state?.message}
                  register={register}
                  setValue={setValue}
                  isWhiteTheme={true}
                  resetValue={resetState}
                  setResetValue={SetResetState}
                  options={states.map((e) => {
                    return { value: e._id, label: e.name };
                  })}
                />
              </div>

              {showDistrict ? (
                <div className="col-md-4">
                  <CustomTextField
                    labelTitle="District"
                    id="district"
                    name="district"
                    placeholder="Enter District"
                    showError={errors?.district}
                    errorMessage={errors?.district?.message}
                    register={register}
                    setValue={setValue}
                    isWhiteTheme={true}
                  />
                </div>
              ) : null}

              {showTaluka ? (
                <div className="col-md-4">
                  <CustomTextField
                    labelTitle="Taluka"
                    id="taluka"
                    name="taluka"
                    placeholder="Enter Taluka"
                    showError={errors?.taluka}
                    errorMessage={errors?.taluka?.message}
                    register={register}
                    setValue={setValue}
                    isWhiteTheme={true}
                  />
                </div>
              ) : null}

              {showPinCode ? (
                <div className="col-md-4">
                  <CustomTextField
                    labelTitle="Pin Code"
                    id="pinCode"
                    name="pinCode"
                    inputType={InputType.number}
                    placeholder="Enter Pin Code"
                    showError={errors?.pinCode}
                    errorMessage={errors?.pinCode?.message}
                    register={register}
                    setValue={setValue}
                    isWhiteTheme={true}

                  />
                </div>
              ) : null}

              <div className="d-flex flex-column gap-1 align-self-start">
                <div className="d-flex align-items-center mt-3">
                  <input type="checkbox" id="terms" {...register("terms")} />
                  <label htmlFor="terms" className="ms-2 medium-text white fw-400" > I agree to these
                    <Link to={RoutesPath?.termsAndConditionsCoordinator} target="_blank" rel="noopener noreferrer">
                      <span className="Termslink ms-1">Terms and Conditions</span>
                    </Link></label>
                </div>

                {errors?.terms && (<span className="danger small-text fw-400 mt-2">{errors?.terms?.message}</span>)}
              </div>
            </div>

            <div className={`d-flex justify-content-end gap-4 align-items-center mt-0 Submitbuttonmobile`}>
              <SubmitButton
                title={"Register Now"}
                onClick={() => {
                  handleSubmit(onSubmit);
                }}
              />
            </div>
          </form>
        </div>

        {/* <div className="join-as-coordinator-announcement col-md-6 col-lg-5  m-0 p-0 ps-4">
          <Image
            src={PngImages.joinAsCoordinatorAnnouncement}
            className
            style={{
              maxWidth: "100%",
              objectFit: "contain",
            }}
          />
        </div> */}
      </div>

      <div className="coordinator-benefits-container register-coordinator-card col-md-12 container">
        <div
          className="coordinator-text-content-card"
          style={{ backgroundColor: "#A98AFF" }}
        >
          <div className="coordinator-rewards-container d-flex gap-4 align-items-center">
            <div className="d-flex flex-column gap-2">
              <h3 className="Small-Heading fw-600 white mb-0">
                Register today and be the catalyst for change in education
              </h3>
              <p className="medium-text fw-400 white mb-0 mt-2">
                Take the step towards a fulfilling and rewarding journey by
                becoming a Coordinator for Bharat SAT Examination with Learn and
                Achieve Edutech. Let's shape the future of education together!
              </p>
            </div>
            <Image
              className="coordinator-rewards-image"
              src={PngImages.registerCoordinator}
              style={{ height: 200 }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default JoinAsCoordinator;
